export default {
  getIntegrationSetting: (state) => state.integrationSetting,
};
